
/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

export default function Footer() {

  return (
    <div className="footer">
      <div className="footer-right">
        <a className="element" href="https://www.rtx.com/Privacy" target="_blank">Privacy Statement</a>
        <a className="element" href="https://links.prattwhitney.com/body/html/terms.html" target="_blank">Website Agreement</a>
        <a className="element" href="mailto:portalidentity@prattwhitney.com" target="_blank">Contact Us</a>
        <a className="element">Help Desk: (860) 565-3550</a>
      </div>
    </div>
  );
}
